import moment from 'moment-timezone';

export const getCurrentOffset = (tz) => {
    const offsetMinutes = moment.tz(tz).utcOffset(); // includes DST
    const hours = Math.floor(offsetMinutes / 60);
    const minutes = Math.abs(offsetMinutes % 60);

    const sign = hours >= 0 ? '+' : '-';
    return `UTC${sign}${String(Math.abs(hours)).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const getAbbreviation = (time_zone)=>{
    const tz = moment.tz(time_zone);
    return tz.zoneAbbr();
}